export const REDUCER_NAME = 'image'



// WEBPACK FOOTER //
// ./src/modules/customer/state/image/const.js